/**
 * ZenMarkup Privacy Analytics — Map Touch Controls (pinch-to-zoom + single-finger pan).
 *
 * Extracted from map-controls.js to keep modules under 200 lines.
 */

/**
 * Bind touch pinch-to-zoom and single-finger pan on a map container.
 *
 * @param {Object} opts  { container, svg, getScale, setScale, getTranslate,
 *                         setTranslate, clampAndApply, ZOOM_MIN, ZOOM_MAX }
 */
export function bind(opts) {
	let startDist = 0;
	let startScale = 1;
	let touchStartX = 0;
	let touchStartY = 0;
	let touchStartTX = 0;
	let touchStartTY = 0;

	/** Distance between two touch points. */
	function pinchDist(t) {
		const dx = t[0].clientX - t[1].clientX;
		const dy = t[0].clientY - t[1].clientY;
		return Math.sqrt(dx * dx + dy * dy);
	}

	opts.container.addEventListener('touchstart', function (e) {
		if (e.touches.length === 2) {
			e.preventDefault();
			startDist = pinchDist(e.touches);
			startScale = opts.getScale();
		} else if (e.touches.length === 1 && opts.getScale() > 1) {
			touchStartX = e.touches[0].clientX;
			touchStartY = e.touches[0].clientY;
			var tr = opts.getTranslate();
			touchStartTX = tr.x;
			touchStartTY = tr.y;
			opts.svg.classList.add('zmpa-map-panning');
		}
	}, { passive: false });

	opts.container.addEventListener('touchmove', function (e) {
		if (e.touches.length === 2) {
			e.preventDefault();
			var dist = pinchDist(e.touches);
			var prev = opts.getScale();
			var newScale = Math.max(opts.ZOOM_MIN, Math.min(opts.ZOOM_MAX, startScale * (dist / startDist)));
			opts.setScale(newScale);

			var rect = opts.container.getBoundingClientRect();
			var cx = (e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left;
			var cy = (e.touches[0].clientY + e.touches[1].clientY) / 2 - rect.top;
			opts.zoomAround(prev, cx, cy);
		} else if (e.touches.length === 1 && opts.getScale() > 1) {
			e.preventDefault();
			opts.setTranslate(
				touchStartTX + (e.touches[0].clientX - touchStartX),
				touchStartTY + (e.touches[0].clientY - touchStartY)
			);
			opts.clampAndApply();
		}
	}, { passive: false });

	opts.container.addEventListener('touchend', function () {
		opts.svg.classList.remove('zmpa-map-panning');
		startDist = 0;
	});
}
